import * as React from 'react'
import CarBrandSelector from './car_brand_selector'

export default function CarBrandSelectorApp(props) {
  return <CarBrandSelector {...props} />
}
